import * as React from 'react'

import { Button, Form } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import CompanyIdentification from 'modules/settings/components/CompanyIdentification'
import CompanyIdentificationForm from 'modules/settings/lib/forms/Identification'

interface Props {
  legalEntity: LegalEntity
}

const Identification = ({ legalEntity }: Props) => {
  const isFranceLegalEntity = legalEntity.isFranceLegalEntity

  const formValues = {
    ...legalEntity.toJS(),
    isFranceLegalEntity,
  }

  const form = React.useRef(new CompanyIdentificationForm(formValues)).current

  const onSubmit = () => {
    asyncAction(() => form.save(legalEntity))
  }

  return (
    <PanesPadForm direction="horizontal">
      <PanesHeader
        illustration="id"
        title={i18n.t('settings.edit_company.tin_form.title')}
        description={i18n.t('settings.edit_company.tin_form.description')}
      />

      <Form onSubmit={onSubmit} withBackground>
        <CompanyIdentification
          form={form}
          isFranceLegalEntity={isFranceLegalEntity}
          legalEntity={legalEntity}
        />

        {form.isDirty && (
          <Form.Buttons>
            <Button disabled={!form.isValid} submit>
              {i18n.t('common.submit')}
            </Button>
          </Form.Buttons>
        )}
      </Form>
    </PanesPadForm>
  )
}

export default observer(Identification)
